"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var theme_ui_1 = require("theme-ui");
var DateInput_1 = require("../../atoms/DateInput/DateInput");
var ErrorText_1 = require("../../atoms/ErrorText/ErrorText");
var Input_1 = require("../../atoms/Input/Input");
var InputLabel_1 = require("../../molecules/InputLabel/InputLabel");
var TextField = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "text" : _b, label = _a.label, error = _a.error, touched = _a.touched, isValid = _a.isValid, adornments = _a.adornments, onChange = _a.onChange, _c = _a.csx, csx = _c === void 0 ? {} : _c, props = __rest(_a, ["type", "label", "error", "touched", "isValid", "adornments", "onChange", "csx"]);
    return (theme_ui_1.jsx(theme_ui_1.Box, { sx: __assign({ width: "100%", mb: 2 }, csx) },
        theme_ui_1.jsx(InputLabel_1.InputLabel, { label: label !== null && label !== void 0 ? label : "", containerSX: { mb: 0 }, adornments: adornments }, type !== "date" ? (theme_ui_1.jsx(Input_1.Input, __assign({ type: Input_1.InputType[type], isValid: touched ? isValid : true, onChange: onChange }, props))) : (theme_ui_1.jsx(DateInput_1.DateInput, __assign({ isValid: touched ? isValid : true, onChange: onChange }, props)))),
        theme_ui_1.jsx(theme_ui_1.Box, { sx: { mt: "4px" } }, touched && !isValid && error && (theme_ui_1.jsx(ErrorText_1.ErrorText, { text: error, csx: { textAlign: "left" } })))));
};
exports.TextField = TextField;
